<template>
  <specialty-form
    @save="onSetCriteriaValue"
    @update-criteria-value="$emit('update-criteria-value', $event)"
    :initial-specialty-id="value.specialtyId"
    :initial-subspecialty-id="value.subspecialtyId"
    :filter-user-count="filterUserCount"
  />
</template>

<script>
import SpecialtyForm from '@/components/recruiter/form/SpecialtyForm';

export default {
  name: 'RecruiterIcoDetailSpecialty',
  components: {
    SpecialtyForm,
  },
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    filterUserCount: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    value: function () {
      return (this.jobQuestion && this.jobQuestion.value) || {};
    },
  },
  methods: {
    onSetCriteriaValue: function (data) {
      this.$emit('set-criteria-value', data);
    },
  },
};
</script>

<style lang="scss" scoped>
.phairify-select-wrapper {
  min-width: 215px;
  &:after {
    content: '\F0140';
    font-size: 22px;
    right: 10px;
  }
  .custom-select {
    height: 100%;
    padding: 15px;
    border-radius: 4px;
  }
}
</style>
